import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import oLocalStorage from '@/services/objectLocalStorage';
import keys from '@/store/keys';
import _ from 'lodash';

// Public pages
import PublicLayout from '@/components/layouts/PublicLayout';
import HomePage from '@/components/public/Home';
import GodfatherPage from '@/components/public/Godfather';
import PublicParkingLayout from '@/components/layouts/PublicParkingLayout';
import NotFound from '@/components/public/NotFound.vue';
import PromoMadridEnero20 from '@/components/public/promo/MadridEnero20.vue';
import MadridSmartbox from '@/components/public/promo/MadridSmartbox.vue';
import ParkFreeOneYear from '@/components/public/promo/ParkFreeOneYear.vue';

// Private pages
import PrivateLayout from '@/components/layouts/PrivateLayout';
import UserHome from '@/components/private/Home';
import Profile from '@/components/private/user/Profile';
import Teletags from '@/components/private/tag/Teletags';
import Prescriptors from '@/components/private/tag/Prescriptor';
import Buy from '@/components/private/balance/Buy';
import Promos from '@/components/private/balance/Promos';
import Godfather from '@/components/private/balance/Godfather';
import Funds from '@/components/private/funds/Funds';
import Business from '@/components/private/business/Business';
import Tenant from '@/components/private/tenant/Tenant';
import ReservationCalendar from '@/components/private/booking/ReservationCalendar';
import ParkingDetail from '@/components/commons/ParkingDetail';
import Faq from '@/components/private/Faq';
import ValidationWait from '@/components/private/user/ValidatingWait';
import TermsOfUsePage from '@/components/public/legal/termsOfUse/TermsOfUse';
import PrivacyPolicyPage from '@/components/public/legal/privacyPolicy/PrivacyPolicy';

// Login pages
import LoginLayout from '@/components/layouts/LoginLayout.vue';
import Login from '@/components/login/Login.vue';
import ForgotPassword from '@/components/login/ForgotPassword.vue';
import ResetPassword from '@/components/login/ResetPassword.vue';
import Logout from '@/components/login/Logout.vue';

// Regsiter page
import RegisterLayout from '@/components/layouts/RegisterLayout.vue';
import Register from '@/components/register/Register.vue';

import langHelper from '@/services/lang';
import userService from '@/services/userService';
import productService from '@/services/productService';

import sessionService from '@/services/sessionService';

Vue.use(Router);

// Catching errors in push replace
// Of course, errors in replace can be captured the same way
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
// push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch(err => err);
};
// replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch(err => err);
};

let publicPages = {
  path: '/',
  component: PublicLayout,
  meta: {
    needsAuth: false
  },
  children: [
    {
      path: '',
      name: 'HomePage',
      component: HomePage,
      alias: ['en', 'ca', 'es', 'cl', 'pe', '/index.html'],
      meta: {
        i18nUrlLabel: 'urlHome',
        i18nTitle: 'titleIndex'
      }
    },
    {
      path: 'the-godfather',
      name: 'GodfatherPage',
      component: GodfatherPage,
      alias: [
        'en/the-godfather',
        'ca/apadrina-un-amic',
        'es/apadrina-un-amigo',
        'cl/apadrina-un-amigo',
      ],
      meta: {
        i18nUrlLabel: 'urlGodfahterPage',
        i18nTitle: 'godfather.title'
      }
    },
    {
      path: 'terms-of-use',
      name: 'termsOfUse',
      component: TermsOfUsePage,
      alias: [
        'en/terms-of-use',
        'ca/terms-of-use',
        'es/terms-of-use',
        'cl/terms-of-use',
      ],
      meta: {
        i18nUrlLabel: 'urlTermsOfUse',
        i18nTitle: 'termsOfUse.title'
      }
    },
    {
      path: 'privacy-policy',
      name: 'privacyPolicy',
      component: PrivacyPolicyPage,
      alias: [
        'en/privacy-policy',
        'ca/privacy-policy',
        'es/privacy-policy',
        'cl/privacy-policy',
      ],
      meta: {
        i18nUrlLabel: 'urlPrivacyPolicy',
        i18nTitle: 'privacyPolicy.title'
      }
    }
  ]
};

let publicFaqPages = {
  path: '/',
  component: PublicParkingLayout,
  children: [
    {
      path: 'faqs',
      name: 'FaqPage',
      component: Faq,
      alias: [
        'en/faqs',
        'ca/preguntes-freqüents',
        'es/preguntas-frecuentes',
        'cl/preguntas-frecuentes',
      ],
      meta: {
        i18nUrlLabel: 'urlFaqPage',
        i18nTitle: 'titleIndex'
      }
    }
  ]
};

let publicPromoPages = {
  path: '/',
  component: PublicParkingLayout,
  children: [
    {
      path: 'condiciones-promo-enero-20',
      name: 'PromoMadridEnero20',
      component: PromoMadridEnero20,
      meta: {
        i18nUrlLabel: 'urlHome',
        i18nTitle: 'titleIndex'
      }
    },
    {
      path: 'condiciones-promo-smartbox',
      name: 'MadridSmartbox',
      component: MadridSmartbox,
      meta: {
        i18nUrlLabel: 'urlHome',
        i18nTitle: 'titleIndex'
      }
    },
    {
      path: 'condiciones-promo-año-gratis',
      name: 'ParkFreeOneYear',
      component: ParkFreeOneYear,
      meta: {
        i18nUrlLabel: 'urlHome',
        i18nTitle: 'titleIndex'
      }
    }
  ]
};

// Se añade `estacionamientos` por una mala configuración en mixpanel
let publicParkingPages = {
  path: '/',
  component: PublicParkingLayout,
  children: [
    {
      path: 'parkings',
      name: 'Home',
      component: UserHome,
      alias: [
        'en/parkings',
        'ca/parquings',
        'es/parkings',
        'cl/estacionamientos',
        'estacionamientos'
      ],
      meta: {
        i18nUrlLabel: 'urlParkingPage',
        i18nTitle: 'titleIndex'
      }
    },
    {
      path: 'parking/:alias',
      props: true,
      name: 'ParkingDetailPage',
      component: ParkingDetail,
      alias: [
        'en/parking/:alias',
        'ca/parquing/:alias',
        'es/parking/:alias',
        'cl/estacionamiento/:alias',
      ],
      meta: {
        i18nUrlLabel: 'urlParkingDetailPage',
        i18nTitle: 'titleIndex'
      }
    }
  ]
};

let loginPages = {
  path: '/',
  component: LoginLayout,
  children: [
    {
      path: 'login',
      name: 'Login',
      component: Login,
      alias: [
        'en/login',
        'ca/inici-sessio',
        'es/inicio-sesion',
        'cl/inicio-sesion',
      ],
      meta: {
        needsAuth: false,
        i18nUrlLabel: 'urlLogin',
        i18nTitle: 'login.title'
      }
    },
    {
      path: 'forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      alias: [
        'en/forgot-password',
        'ca/canvi-clau',
        'es/cambio-password',
        'cl/cambio-password',
      ],
      meta: {
        needsAuth: false,
        i18nUrlLabel: 'urlForgotPassword',
        i18nTitle: 'forgot.password.title'
      }
    },
    {
      path: 'reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
      // backward compatibility (Julio 2019)
      // confirmar con app mobil
      // TODO: eliminar
      // 'cambiar-password',
      // 'canviar-contrasenya',
      // 'restore-password'
      alias: [
        'en/reset-password',
        'ca/resetejar-clau',
        'es/resetear-password',
        'cl/resetear-password',
        'en/cambiar-password',
        'ca/cambiar-password',
        'es/cambiar-password',
        'cl/cambiar-password',
        'cambiar-password',
        'canviar-contrasenya',
        'restore-password'
      ],
      meta: {
        needsAuth: false,
        i18nUrlLabel: 'urlResetPassword',
        i18nTitle: 'reset.password.title'
      }
    },
    {
      path: 'logout',
      name: 'Logout',
      component: Logout,
      meta: {
        needsAuth: false,
        i18nUrlLabel: '',
        i18nTitle: ''
      }
    }
  ]
};

let registerPages = {
  path: '/',
  component: RegisterLayout,
  children: [
    {
      path: 'register',
      name: 'Register',
      component: Register,
      alias: [
        'ca/registre',
        'en/register',
        'es/registro',
        'cl/registro',
        '/es/iniciar-registro',
        '/cl/iniciar-registro'
      ],
      meta: {
        i18nUrlLabel: 'urlRegister',
        i18nTitle: 'register.title'
      }
    },
    {
      path: 'user/validationWait',
      name: 'ValidationWait',
      component: ValidationWait,
      alias: [
        'en/user/validation-wait',
        'ca/usuari/esperant-validacio',
        'es/usuario/esperando-validacion',
        'cl/usuario/esperando-validacion',
      ],
      meta: {
        i18nUrlLabel: 'urlValidationWait',
        i18nTitle: 'user.validation.wait'
      }
    }
  ]
};

let privatePages = {
  path: '/',
  component: PrivateLayout,
  meta: {
    needsAuth: true
  },
  children: [
    {
      path: 'user/park',
      name: 'UserHome',
      component: UserHome,
      alias: [
        'user',
        'en/user',
        'ca/usuari',
        'es/usuario',
        'cl/usuario',
        'en/user/park',
        'ca/usuari/aparcar',
        'es/usuario/aparcar',
        'cl/usuario/estacionar',
        'es/buscador-parkings',
        'ca/cercador-parquings',
        'en/search-parkings'
      ],
      meta: {
        i18nUrlLabel: 'urlUser',
        i18nTitle: 'home.map.title'
      }
    },
    {
      path: 'user/profile',
      name: 'Profile',
      component: Profile,
      alias: [
        'en/user/profile',
        'ca/usuari/perfil',
        'es/usuario/perfil',
        'cl/usuario/perfil',
        'change-email', // compatibilidad link antiguos que manda backemd
        'cambiar-email' // compatibilidad link antiguos que manda backemd
      ],
      meta: {
        i18nUrlLabel: 'urlProfile',
        i18nTitle: 'profile.title'
      }
    },
    {
      path: 'user/teletags',
      name: 'TeletagList',
      props: true,
      component: Teletags,
      alias: [
        'en/user/teletags',
        'ca/usuari/teletacs',
        'es/usuario/teletags',
        'cl/usuario/sticker-tags',
        'es/usuario/pegatinas',
        'ca/usuari/enganxines',
        'en/user/stickers',
        'getTag'
      ],
      meta: {
        i18nUrlLabel: 'urlTeletac',
        i18nTitle: 'teletag.title'
      }
    },
    {
      path: 'user/buy',
      name: 'Buy',
      component: Buy,
      alias: [
        'en/user/buy',
        'ca/usuari/comprar',
        'es/usuario/comprar',
        'cl/usuario/comprar',
        'balance'
      ],
      meta: {
        i18nUrlLabel: 'urlBuy',
        i18nTitle: 'buy.title'
      }
    },
    {
      path: 'user/discounts',
      name: 'Promos',
      component: Promos,
      alias: [
        'en/user/discounts',
        'ca/usuari/promos',
        'es/usuario/promos',
        'cl/usuario/promos',
        'winhours'
      ],
      meta: {
        i18nUrlLabel: 'urlPromos',
        i18nTitle: 'promos.title'
      }
    },
    {
      path: 'user/funds',
      name: 'Funds',
      component: Funds,
      alias: [
        'en/user/funds',
        'ca/usuari/moviments',
        'es/usuario/movimientos',
        'cl/usuario/movimientos',
      ],
      meta: {
        i18nUrlLabel: 'urlFunds',
        i18nTitle: 'funds.title'
      }
    },
    {
      path: 'user/business',
      name: 'Business',
      component: Business,
      alias: [
        'en/user/business',
        'ca/usuari/empresa',
        'es/usuario/empresa',
        'cl/usuario/empresa',
      ],
      meta: {
        i18nUrlLabel: 'urlBusiness',
        i18nTitle: 'business.title'
      }
    },
    {
      path: 'user/tenant',
      name: 'Tenant',
      component: Tenant,
      alias: [
        'tenant/apply',
        'en/user/tenant',
        'ca/usuari/llogater',
        'es/usuario/inquilino',
        'cl/usuario/inquilino',
      ],
      meta: {
        i18nUrlLabel: 'urlTenant',
        i18nTitle: 'tenant.title'
      }
    },
    {
      path: 'user/faq',
      name: 'Faq',
      component: Faq,
      alias: [
        'en/user/faq',
        'ca/usuari/preguntes-freqüents',
        'es/usuario/preguntas-frecuentes',
        'cl/usuario/preguntas-frecuentes',
      ],
      meta: {
        i18nUrlLabel: 'urlFaq',
        i18nTitle: 'faq.title'
      }
    },
    {
      path: 'user/bookings',
      name: 'ReservationCalendar',
      component: ReservationCalendar,
      alias: [
        'en/user/bookings',
        'ca/usuari/reserves',
        'es/usuario/reservas',
        'cl/usuario/reservas',
      ],
      meta: {
        i18nUrlLabel: 'urlMyReservations',
        i18nTitle: 'reservation.title'
      }
    },
    {
      path: 'user/invite-a-friend',
      name: 'Godfather',
      component: Godfather,
      alias: [
        'ca/usuari/apadrina-un-amic',
        'es/usuario/apadrina-un-amigo',
        'en/user/invite-a-friend',
        'cl/usuario/apadrina-un-amigo',
        'es/usuario/promos/apadrina-un-amigo',
        'ca/usuari/promos/apadrina-un-amic',
        'en/user/discounts/invite-a-friend',
        'cl/usuario/promos/apadrina-un-amigo',
      ],
      meta: {
        i18nUrlLabel: 'urlGodfather',
        i18nTitle: 'godfather.title'
      }
    },
    {
      path: 'user/park/:alias',
      props: true,
      name: 'ParkingDetail',
      component: ParkingDetail,
      alias: [
        'en/user/park/:alias',
        'ca/usuari/aparcar/:alias',
        'es/usuario/aparcar/:alias',
        'cl/usuario/estacionar/:alias',
      ],
      meta: {
        i18nUrlLabel: 'urlParkingDetail',
        i18nTitle: ''
      }
    },
    {
      path: '/user/get-sticker',
      props: true,
      name: 'Prescriptors',
      component: Prescriptors,
      alias: [
        'en/user/get-sticker',
        'ca/usuari/conseguir-enganxina',
        'es/usuario/conseguir-pegatina',
        'cl/usuario/conseguir-sticker-tag',
        'es/prescriptores/conseguir-pegatina',
        'ca/prescriptors/aconseguir-pegatina',
        'en/prescribers/get-sticker'
      ],
      meta: {
        i18nUrlLabel: 'urlPrescriptor',
        i18nTitle: 'prescriptor.title'
      }
    }
  ]
};

let notFound = {
  path: '*',
  name: 'NotFound',
  component: NotFound
};

let routes = [];
routes.push(publicPages);
routes.push(publicParkingPages);
routes.push(privatePages);
routes.push(loginPages);
routes.push(registerPages);
routes.push(publicFaqPages);
routes.push(notFound);
routes.push(publicPromoPages);

const router = new Router({
  mode: 'history',
  routes: routes
});

router.beforeEach(async (to, from, next) => {
  let i18n = langHelper(store.state.langSelected.langIso);

  if (from.name !== null) {
    store.commit('UPDATE_LAST_ROUTE', {
      from: from
    });
  }
  if (store.state.isLogged) {
    await sessionService.check(false);
  }

  if (
    store.state.isLogged &&
    userService.noPhoneValidated() &&
    to.name !== 'Register' &&
    to.name !== 'Logout'
  ) {
    next(`${i18n.t('urlRegister')}`);
    return;
  }

  if (
    store.state.isLogged &&
    to.name === 'TeletagList' &&
    userService.registeredWithBle()
  ) {
    next(`${i18n.t('urlUser')}`);
    return;
  }

  if (store.state.isLogged && to.name === 'Login' && to.name !== 'Logout') {
    next(`${i18n.t('urlUser')}`);
    return;
  }

  if (
    store.state.isLogged &&
    to.name === 'ParkingDetailPage' &&
    to.name !== 'Logout'
  ) {
    next(
      i18n.t('urlParkingDetail', {
        alias: to.params.alias
      })
    );
    return;
  }

  if (typeof to.query.TPV !== 'undefined') {
    if (typeof to.query.subscription === 'undefined') {
      let paymentId = to.query.payment;
      if (typeof paymentId === 'undefined') {
        paymentId = to.query.paymentId;
      }

      let goTo = `${i18n.t('urlBuy')}?ok=${to.query.TPV}`;

      if (typeof paymentId !== 'undefined') {
        goTo = `${goTo}&paymentId=${paymentId}`;
      }

      next(goTo);
      return;
    } else {
      let parkingAlias = oLocalStorage.get(
        keys.lastParkingAliasBoughtSubscription
      );
      if (parkingAlias !== null) {
        const goTo = `${i18n.t('urlParkingDetail', {
          alias: parkingAlias.alias
        })}?ok=${to.query.TPV}&subscriptionId=${to.query.subscription}${
          typeof to.query.payment !== 'undefined'
            ? '&paymentId=' + to.query.payment
            : ''
        }`;

        next(goTo);
        return;
      }
    }
  }

  let params = {
    text: to.meta.i18nTitle,
    routeName: '',
    disabled: true
  };

  store.commit('CHANGE_TITLE_SECTION', params);

  let needsAuth = to.meta.needsAuth;
  if (typeof needsAuth === 'undefined') {
    let needsAuthExists = _.find(to.matched, it => it.meta.needsAuth);
    needsAuth = typeof needsAuthExists !== 'undefined';
  }

  if (needsAuth) {
    if (!store.state.isLogged) {
      store.commit('UPDATE_GO_TO_ROUTE_AFTER_LOGIN', {
        to: to
      });
      next(`${i18n.t('urlLogin')}`);
      return;
    }
  }

  if (to.name === 'Buy' && !productService.canBuyPack()) {
    next(`${i18n.t('urlUser')}`);
    return;
  }
  // else {
  // next('/es/usuario/aparcar');
  // console.dir(i18n)
  // console.log(i18n.t('urlUser'))

  // next({
  //   path: this.$i18n.t('urlUser')
  // });
  // }
  // }
  next();
});

export default router;
